module.exports = __webpack_public_path__ + "static/media/digital-lock.c0723a83.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/digital-lock.png
// module id = 173
// module chunks = 0